import OwlCarousel from 'react-owl-carousel';  
import 'owl.carousel/dist/assets/owl.carousel.css';  
import 'owl.carousel/dist/assets/owl.theme.default.css';  
import slider_1 from '../../img/slider_1.jpg'
import slider_1_2 from '../../img/slider_1-2.jpg'
import slider_1_3 from '../../img/slider_1-3.jpg'

import slider_2 from '../../img/slider_2.jpg'
import slider_2_2 from '../../img/slider_2-2.jpg'
import slider_2_3 from '../../img/slider_2-3.jpg'

import slider_3 from '../../img/slider_3.jpg'
import slider_3_2 from '../../img/slider_3-2.jpg'
import slider_3_3 from '../../img/slider_3-3.jpg'

import slider_4 from '../../img/slider_4.jpg'
import slider_4_2 from '../../img/slider_4-2.jpg'
import slider_4_3 from '../../img/slider_4-3.jpg'

import slider_5 from '../../img/slider_5.jpg'
import slider_5_2 from '../../img/slider_5-2.jpg'
import slider_5_3 from '../../img/slider_5-3.jpg'

function S6_home() {
     
    return (
        <section className="S6_home">
            <div className="container">

           
<OwlCarousel className="owl-theme" items={1} loop nav dots={0} navText={['<i class="fa-solid fa-angle-left"></i>','<i class="fa-solid fa-angle-right"></i>']} margin={10} >


    <div className='item' >  
        <div className='row'>
            <div className='col-lg-6 col-md-12 col-sm-12'>
                <div className='row'>
                    <div className='col-lg-8 col-md-8 '>
                                <div className='slider_imges'>
                    <img src={slider_1} alt='sora' />
                        </div>
                    </div>    
                    
                    <div className='col-lg-4 col-md-4  slider_imges_on_sm'>
                        <div className='slider_imges mb-4'>
                            <img src={slider_1_2} alt='sora'/> 
                                        </div>

                         <div className='slider_imges'>
                            <img src={slider_1_3} alt='sora' /> 
                                        </div>
                     </div>   
                    

                </div>
            </div>
            <div className='col-lg-6 col-md-12 col-sm-12 left_side'>
                        <span>June 01, 2022</span>
                        <h4>Mini Game Lounch For Community</h4> 
                        <p>Morbi non dignissim erat, a blandit felis. Suspendisse nec lorem vel orci varius congue ut vitae est. Nam quis tempus nisl. Fusce posuere nibh a mi molestie, sit amet ornare lectus interdum.</p>
                        <button>Read More</button>
                    </div>     
            </div>
            </div>  
            
                    
    <div className='item' >  
        <div className='row'>
            <div className='col-lg-6 col-md-12 col-sm-12'>
                <div className='row'>
                    <div className='col-lg-8 col-md-8 col-sm-8'>
                                <div className='slider_imges'>
                    <img src={slider_2} alt='sora' />
                        </div>
                    </div>    
                    
                    <div className='col-lg-4 col-md-4 col-sm-4  slider_imges_on_sm'>
                        <div className='slider_imges mb-4'>
                            <img src={slider_2_2} alt='sora' /> 
                                        </div>

                         <div className='slider_imges'>
                            <img src={slider_2_3} alt='sora' /> 
                                        </div>
                     </div>   
                    

                </div>
            </div>
            <div className='col-lg-6 col-md-12 col-sm-12 left_side'>
                        <span>May 05, 2022</span>
                        <h4>New Character Set #12 is Coming Up</h4> 
                        <p>Morbi non dignissim erat, a blandit felis. Suspendisse nec lorem vel orci varius congue ut vitae est. Nam quis tempus nisl. Fusce posuere nibh a mi molestie, sit amet ornare lectus interdum.</p>
                        <button>Read More</button>
                    </div>     
            </div>
            </div>  

    <div className='item' >  
        <div className='row'>
            <div className='col-lg-6 col-md-12 col-sm-12'>
                <div className='row'>
                    <div className='col-lg-8 col-md-8 col-sm-8'>
                                <div className='slider_imges'>
                    <img src={slider_3} alt='sora' />
                        </div>
                    </div>    
                    
                    <div className='col-lg-4 col-md-4 col-sm-4  slider_imges_on_sm'>
                        <div className='slider_imges mb-4'>
                            <img src={slider_3_2} alt='sora' /> 
                                        </div>

                         <div className='slider_imges'>
                            <img src={slider_3_3} alt='sora' /> 
                                        </div>
                     </div>   
                    

                </div>
            </div>
            <div className='col-lg-6 col-md-12 col-sm-12 left_side'>
                        <span>May 27, 2022</span>
                        <h4>Female Character Set #20 is Coming Up</h4> 
                        <p>Morbi non dignissim erat, a blandit felis. Suspendisse nec lorem vel orci varius congue ut vitae est. Nam quis tempus nisl. Fusce posuere nibh a mi molestie, sit amet ornare lectus interdum.</p>
                        <button>Read More</button>
                    </div>     
            </div>
            </div> 

    <div className='item' >  
        <div className='row'>
            <div className='col-lg-6 col-md-12 col-sm-12'>
                <div className='row'>
                    <div className='col-lg-8 col-md-8 col-sm-8'>
                                <div className='slider_imges'>
                    <img src={slider_4} alt='sora' />
                        </div>
                    </div>    
                    
                    <div className='col-lg-4 col-md-4 col-sm-4  slider_imges_on_sm'>
                        <div className='slider_imges mb-4'>
                            <img src={slider_4_2} alt='sora' /> 
                                        </div>

                         <div className='slider_imges'>
                            <img src={slider_4_3} alt='sora' /> 
                                        </div>
                     </div>   
                    

                </div>
            </div>
            <div className='col-lg-6 col-md-12 col-sm-12 left_side'>
                        <span>June 01, 2022</span>
                        <h4>New Haircut Collection #01 is Coming Up</h4> 
                        <p>Morbi non dignissim erat, a blandit felis. Suspendisse nec lorem vel orci varius congue ut vitae est. Nam quis tempus nisl. Fusce posuere nibh a mi molestie, sit amet ornare lectus interdum.</p>
                        <button>Read More</button>
                    </div>     
            </div>
            </div>  
 
    <div className='item' >  
        <div className='row'>
            <div className='col-lg-6 col-md-12 col-sm-12'>
                <div className='row'>
                    <div className='col-lg-8 col-md-8 col-sm-8'>
                                <div className='slider_imges'>
                    <img src={slider_5} alt='sora' />
                        </div>
                    </div>    
                    
                    <div className='col-lg-4 col-md-4 col-sm-4  slider_imges_on_sm'>
                        <div className='slider_imges mb-4'>
                            <img src={slider_5_2} alt='sora' /> 
                                        </div>

                         <div className='slider_imges'>
                            <img src={slider_5_3} alt='sora' /> 
                                        </div>
                     </div>   
                    

                </div>
            </div>
            <div className='col-lg-6 col-md-12 col-sm-12 left_side'>
                        <span>July 01, 2022</span>
                        <h4>New Haircut Collection #02 is Coming Up</h4> 
                        <p>Morbi non dignissim erat, a blandit felis. Suspendisse nec lorem vel orci varius congue ut vitae est. Nam quis tempus nisl. Fusce posuere nibh a mi molestie, sit amet ornare lectus interdum.</p>
                        <button>Read More</button>
                    </div>     
            </div>
            </div>  

  

</OwlCarousel>  

 

  

            </div>
        </section>
    )
}
 
export default S6_home;